<template>
  <el-form :model="form" ref="form" label-width="100px" size="mini" style="margin-right: 50px;">
    <el-row>
      <el-col :span="9">
<!--        <el-select v-model="form.qrcode_style" placeholder="选择任务类型">-->
<!--          <el-option v-for="item in [{name:'公众号',id:1},{name:'企业微信',id:2}]" :label="item.name" :value="item.id" :key="item.id"></el-option>-->
<!--        </el-select>-->
        <div class="calendar-table">
          <el-calendar v-model="to_date" @change="onCalendar">
            <template slot="dateCell" slot-scope="{date, data}">
              <div class="calendar-table-td" :class="getClassNames(data)" @click="onClick(data)">
                {{ data.day.split('-').slice(2).toString() }} {{ data.isSelected ? '✔️' : ''}}
              </div>
            </template>
          </el-calendar>
        </div>
      </el-col>
      <el-col :span="9">
        <el-form-item label="播报时间" prop="name">
          {{form.broadcast_time}}
        </el-form-item>
        <el-form-item label="背景图" prop="background">
          <UploadFileSysc v-model="form.background" :host-url="host_url" :upload-url="host_url+'/admin/common/uploadFile?name=card_poster'" />
          <p style="color: #F56C6C;">请上传背景图尺寸为：750*1345 px</p>
        </el-form-item>
        <el-form-item label="报文" prop="content">
          <el-input v-model="form.content" type="textarea" :rows="3" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="字体色" prop="font_color">
          <el-color-picker v-model="form.font_color"></el-color-picker>
        </el-form-item>
        <el-form-item label="二维码选项" prop="qrcode_style">
          <el-select v-model="form.qrcode_style" placeholder="选择二维码">
            <el-option v-for="item in [{name:'公众号',id:1},{name:'企业微信',id:2}]" :label="item.name" :value="item.id" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-switch :active-value="1" :inactive-value="0" v-model="form.status" />
        </el-form-item>
        <el-form-item label="" prop="status">
          <el-button type="primary" @click="deleteForm()">删 除</el-button>
          <el-button type="primary" @click="submitForm()">确 定</el-button>
        </el-form-item>
      </el-col>
      <el-col :span="4">
        <div style="padding: 20px">
          <el-image style="width: 250px;height: 415px" :src="hostUrl(form.img_file)"></el-image>
        </div>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
import UploadFileSysc from "./UploadFileSysc";
import xhHelp from "../xhHelp";
export default {
  name: "CardPosterTime",
  components: {UploadFileSysc},
  data(){
    return{
      to_date:new Date(),
      form:{
        poster_id:"",
        broadcast_time:"",
        background:"",
        content:"",
        font_color:"",
        qrcode_style:"",
        status:1,
        img_file:""
      },
      hostUrl:xhHelp.hostUrl,
      host_url:xhHelp.host_url,
      poster_time_list:[],
      poster_time_list_obj:[]
    }
  },
  props:{
    poster_id:{
      type:Number|String
    }
  },
  watch:{
    poster_id(n,o){
      this.form.poster_id=n;
    },
    to_date(n,o){
      if(o){
        if(xhHelp.date("YYYY-MM",n)!==xhHelp.date("YYYY-MM",o)){
          this.getPosterTimeList(xhHelp.date("YYYY-MM",n))
        }
      }
    }
  },
  created() {
    this.form.poster_id=this.poster_id;
    this.getPosterTimeList(xhHelp.date("YYYY-MM",new Date()))
  },
  methods:{
    getPosterTimeList(YM){
      const that=this;
      xhHelp.get('CardPosterTime/getPosterTimeList',{
        poster_id:that.form.poster_id,
        broadcast_time:YM
      },ret=>{
        if(ret.code){
          ret.data&&(that.poster_time_list=ret.data)
        }else {
          that.$message.error(ret.msg||'数据加载异常')
        }
      })
    },
    onClick(obj){
      const that=this;
      let data=JSON.parse(JSON.stringify(obj))
      that.insetForm()
      that.form.broadcast_time=data.day;
      that.getData()
    },
    getData(){
      const that=this;
      xhHelp.get('CardPosterTime/getCardPoster',{
        poster_id:that.form.poster_id,
        broadcast_time:that.form.broadcast_time
      },ret=>{
        if(ret.code){
          ret.data&&(that.form=ret.data)
        }else {
          that.$message.error(ret.msg||'数据加载异常')
        }
      })
    },
    submitForm(){
      const that=this;
      xhHelp.post('CardPosterTime/updateCardPoster',that.form,ret=>{
        if(ret.code){
          that.getData()
          that.getPosterTimeList(xhHelp.date("YYYY-MM",that.to_date))
        }else {
          that.$message.error(ret.msg||'操作异常')
        }
      })
    },
    deleteForm(){
      const that=this;
      xhHelp.post('CardPosterTime/delCardPoster',{
        poster_id:that.form.poster_id,
        broadcast_time:that.form.broadcast_time
      },ret=>{
        if(ret.code){
          that.insetForm()
          that.getPosterTimeList(xhHelp.date("YYYY-MM",that.to_date))
        }else {
          that.$message.error(ret.msg||'数据加载异常')
        }
      })
    },
    insetForm(){
      this.form={
        poster_id:this.poster_id,
        broadcast_time:"",
        background:"",
        content:"",
        font_color:"",
        qrcode_style:"",
        status:1,
        img_file:""
      }
    },
    onCalendar(e){
      console.log(e);
    },
    getClassNames(data){
      let className="";
      className+=data.isSelected ? ' is-selected ' : ' ';
      className+=this.poster_time_list.findIndex(ret=>ret.broadcast_time===data.day)===-1?' ':' set-time ';
      return className;
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../common.scss';
/deep/.calendar-table .el-calendar-day {
  height: 50px;
  padding: 0;
}
.calendar-table-td{
  height: 50px;
}
.set-time{
  background-color: #d0fcc9;
}
.is-selected{
  background-color: #e8e8e8;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/App/Card/components/CardPosterTime.vue